import { SourceSystem } from "./BaseSourceSystem";
import React from "react";

export class BranchAppraisalSourceSystem extends SourceSystem {
  constructor(redirectUri: string, exitUri: string, navigate: INavigate) {
    super(redirectUri, exitUri, navigate);
    this.name = "branch-appraisal";
    this.photosRequired = true;
    this.errorUri = redirectUri || "/valuation-admin";
    this.stepCount = 8;
    this.quickValuation = false;
    this.showPrivacyStatement = true;
    this.showEstimatedOfferPartExchange = true;
    this.showBranchValuationContent = true;
    this.analyticsJourney = "Branch reuse";
    this.photoGalleryContent = {
      stepNumber: 6
    };
    this.initialOfferContent = {
      offerLabel: "We'll offer you",
      cta: "Save and submit valuation",
      subheaderTitle: "Your valuation",
      ctaMicro:
        "Next, the branch manager will give this a once over and lock in this valuation.",
      assumptionsCopy:
        "*Your personalised offer is subject to a full appraisal and is based on these assumptions.",
      renderImageUpload: false,
      stepNumber: 7,
      whatHappensNextContent: (
        <>
          <p>
            Once you’ve submitted your answers and photos, these will be sent to
            your Product Consultant to review.
          </p>
          <p>
            They will then give you a call to discuss your valuation and arrange
            a full branch appraisal.
          </p>
          <p>
            Your final price will then be agreed in consultation with you at
            your branch appraisal.
          </p>
        </>
      ),
      assumptionsContent: (
        <div className="ch-display--flex">
        <span className="ch-fs--3 ch-text--center ch-color--ac-black">
          * This price is based on your answers and{" "}
          <button
            className="ch-btn ch-btn--link ch-pa--0 ch-fs--3"
            onClick={() => {
              navigate("/assumptions");
            }}
          >
            these assumptions
          </button>
          .
        </span>
      </div>
      )
    };
    this.handleAssumptionsOnSubmit = () => {
      navigate("/estimated-offer");
    };
  }
}
